export enum ToasterTypeEnum {
  DEFAULT = 'default',
}
